module.exports = __webpack_public_path__ + "img/right-arrow.a55f8bbd.svg";